var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"position-absolute package-info-container text-grey-900 caption text-wrap d-none d-md-flex font-size-12 line-height-14 py-2 d-flex flex-column justify-content-center position-absolute",style:({
		top: _setup.props.top,
		left: _setup.props.left,
		'border-radius': _setup.props.radius,
	})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }